import { Institution, ResponseStatus } from "@/api/dtos";
import { createContext } from "react"

export interface IInstitutionContext {
    data?: Institution;
    id?: number;
    error?: ResponseStatus;
    loading: boolean;
    validating: boolean;
    refresh: () => Promise<Institution | undefined>
}

export const InstitutionContext = createContext<IInstitutionContext>({
    loading: false,
    validating: false,
    data: undefined,
    error: undefined,
    refresh: () => {
        return new Promise<Institution | undefined>(res => {
            res(undefined);
        });
    }
});

export default InstitutionContext;